<template>
  <div>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.svg" />
    </vue-element-loading>
    <b-row>
      <b-col cols="12" xl="12">
        <transition name="slide">
          <b-card>
            <template slot="header">
              <b-row>
                <b-col cols="12" md="3" class="py-2">
                  <span>Customer Details</span>
                </b-col>
              </b-row>
            </template>
            <b-row v-if="order">
              <b-col cols="12" md="6">
                <b-row>
                  <b-col cols="5" xl="3">
                    <span class="item_title"> Name</span>
                  </b-col>
                  <b-col cols="7" xl="9">
                    <span class="item_value">{{ order.customer.name }}</span>
                  </b-col>
                </b-row>
                <hr />
              </b-col>
              <b-col cols="12" md="6">
                <b-row>
                  <b-col cols="5" xl="3">
                    <span class="item_title"> Mobile No</span>
                  </b-col>
                  <b-col cols="7" xl="9">
                    <span class="item_value">{{
                      order.customer.mobileno
                    }}</span>
                  </b-col>
                </b-row>
                <hr />
              </b-col>
              <b-col cols="12" md="6">
                <b-row>
                  <b-col cols="5" xl="3">
                    <span class="item_title"> Email</span>
                  </b-col>
                  <b-col cols="7" xl="9">
                    <span class="item_value">{{ order.customer.email }}</span>
                  </b-col>
                </b-row>
                <hr />
              </b-col>
              <b-col cols="12" md="6">
                <b-row>
                  <b-col cols="5" xl="3">
                    <span class="item_title"> Username</span>
                  </b-col>
                  <b-col cols="7" xl="9">
                    <span class="item_value">{{
                      order.customer.username
                    }}</span>
                  </b-col>
                </b-row>
                <hr />
              </b-col>
              <!-- <b-col cols="12">
                <b-row>
                  <b-col cols="2">
                    <span class="item_title"> Address</span>
                  </b-col>
                  <b-col cols="10">
                    <span class="item_value">{{ order.customer.address }}</span>
                  </b-col>
                </b-row>
                <hr />
              </b-col> -->
            </b-row>
          </b-card>
        </transition>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">
        <transition name="slide">
          <b-card>
            <template slot="header">
              <b-row>
                <b-col cols="12" md="3" class="py-2">
                  <span>Order Details</span>
                </b-col>
              </b-row>
            </template>

            <b-row v-if="order">
              <b-col cols="12" md="6">
                <b-row>
                  <b-col cols="5" xl="3">
                    <span class="item_title"> Total Price</span>
                  </b-col>
                  <b-col cols="7" xl="9">
                    <span class="item_value">{{ order.total_price }}</span>
                  </b-col>
                </b-row>
                <hr />
              </b-col>
              <b-col cols="12" md="6">
                <b-row>
                  <b-col cols="5" xl="3">
                    <span class="item_title"> Price</span>
                  </b-col>
                  <b-col cols="7" xl="9">
                    <span class="item_value">{{ order.price }}</span>
                  </b-col>
                </b-row>
                <hr />
              </b-col>
              <b-col cols="12" md="6">
                <b-row>
                  <b-col cols="5" xl="3">
                    <span class="item_title"> Delivery Charge</span>
                  </b-col>
                  <b-col cols="7" xl="9">
                    <span class="item_value" v-if="order.payment != 3">{{
                      order.delivery_charge
                    }}</span>
                    <span class="item_value" v-else>Nill</span>
                  </b-col>
                </b-row>
                <hr />
              </b-col>
              <b-col cols="12" md="6">
                <b-row>
                  <b-col cols="5" xl="3">
                    <span class="item_title"> Order Time</span>
                  </b-col>
                  <b-col cols="7" xl="9">
                    <span class="item_value">{{
                      formatDate(order.ordered_at)
                    }}</span>
                  </b-col>
                </b-row>
                <hr />
              </b-col>
              <b-col cols="12" md="6">
                <b-row>
                  <b-col cols="5" xl="3">
                    <span class="item_title"> Fulfilment Time</span>
                  </b-col>
                  <b-col cols="7" xl="9">
                    <span class="item_value">{{
                      formatDate(order.fulfilment_at)
                    }}</span>
                  </b-col>
                </b-row>
                <hr />
              </b-col>
              <b-col cols="12" md="6">
                <b-row>
                  <b-col cols="5" xl="3">
                    <span class="item_title"> Delivery Time</span>
                  </b-col>
                  <b-col cols="7" xl="9">
                    <span class="item_value">{{
                      formatDate(order.delivery_time)
                    }}</span>
                  </b-col>
                </b-row>
                <hr />
              </b-col>
              <b-col cols="12" md="6">
                <b-row>
                  <b-col cols="5" xl="3">
                    <span class="item_title"> Order Id</span>
                  </b-col>
                  <b-col cols="7" xl="9">
                    <span class="item_value">{{ order._id }}</span>
                  </b-col>
                </b-row>
                <hr />
              </b-col>
              <b-col cols="12" md="6">
                <b-row>
                  <b-col cols="12" xl="3">
                    <span class="item_title"> Order Status</span>
                  </b-col>
                  <b-col cols="12" xl="9">
                    <b-row class="text-center">
                      <b-col cols="12" lg="8" class="text-center">
                        <b-form-select
                          :disabled="orderStatusBtn"
                          v-model="order.status"
                          id="orderStatus"
                          :options="orderStatuses"
                          text-field="name"
                          value-field="value"
                        ></b-form-select>
                      </b-col>
                      <b-col cols="12" lg="4" align-self="center">
                        <b-button
                          :disabled="orderStatusBtn"
                          @click="confirmUpdateStatus"
                          size="sm"
                          variant="danger"
                        >
                          Update Status
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <hr />
              </b-col>
            </b-row>
          </b-card>
        </transition>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">
        <transition name="slide">
          <b-card>
            <template slot="header">
              <b-row>
                <b-col cols="12" md="3" class="py-2">
                  <span>Delivery Address</span>
                </b-col>
              </b-row>
            </template>
            <b-row v-if="order">
              <b-col cols="12" md="6">
                <b-row>
                  <b-col cols="5" xl="3">
                    <span class="item_title"> Address 1</span>
                  </b-col>
                  <b-col cols="7" xl="9">
                    <span class="item_value">{{
                      order.delivery_address.addr1
                    }}</span>
                  </b-col>
                </b-row>
                <hr />
              </b-col>
              <b-col cols="12" md="6">
                <b-row>
                  <b-col cols="5" xl="3">
                    <span class="item_title"> Address 2</span>
                  </b-col>
                  <b-col cols="7" xl="9">
                    <span class="item_value">{{
                      order.delivery_address.addr2
                    }}</span>
                  </b-col>
                </b-row>
                <hr />
              </b-col>
              <b-col cols="12" md="6">
                <b-row>
                  <b-col cols="5" xl="3">
                    <span class="item_title"> Pincode</span>
                  </b-col>
                  <b-col cols="7" xl="9">
                    <span class="item_value">{{
                      order.delivery_address.pincode
                    }}</span>
                  </b-col>
                </b-row>
                <hr />
              </b-col>
              <b-col cols="12" md="6">
                <b-row>
                  <b-col cols="5" xl="3">
                    <span class="item_title"> State</span>
                  </b-col>
                  <b-col cols="7" xl="9">
                    <span class="item_value">{{
                      order.delivery_address.state
                    }}</span>
                  </b-col>
                </b-row>
                <hr />
              </b-col>
            </b-row>
          </b-card>
        </transition>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" xl="12">
        <transition name="slide">
          <b-card>
            <template slot="header">
              <b-row>
                <b-col cols="12" md="3" class="py-2">
                  <span>Ordered Items</span>
                </b-col>
              </b-row>
            </template>
            <b-row>
              <b-col cols="12">
                <b-table
                  :hover="true"
                  :striped="true"
                  :bordered="false"
                  :small="false"
                  :fixed="false"
                  responsive="sm"
                  :items="order.order_items"
                  :fields="fields"
                  @row-clicked="rowClicked"
                >
                  <template v-slot:cell(item_name)="data">
                    <span v-if="data.item.item_name.length > 50">{{
                      data.item.item_name.slice(0, 50) + "..."
                    }}</span>
                    <span v-else>{{ data.item.item_name }}</span>
                  </template>
                  <template v-slot:cell(order_item)="data">
                    <b-button
                      @click="rowClicked(data.item)"
                      size="sm"
                      variant="success"
                    >
                      View Product
                    </b-button>
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </b-card>
        </transition>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">
        <transition name="slide">
          <b-card>
            <template slot="header">
              <b-row>
                <b-col cols="12" md="3" class="py-2">
                  <span>Payment Details</span>
                </b-col>
              </b-row>
            </template>
            <b-row v-if="order.payment == 1">
              <b-col cols="12" md="6">
                <b-row>
                  <b-col cols="6" xl="4">
                    <span class="item_title"> Payment Method</span>
                  </b-col>
                  <b-col cols="6" xl="8">
                    <span class="item_value"> Cash On Delivery </span>
                  </b-col>
                </b-row>
                <hr />
              </b-col>
            </b-row>
            <b-row v-if="order.payment == 2">
              <b-col cols="12" md="6">
                <b-row>
                  <b-col cols="5" xl="3">
                    <span class="item_title"> Amount</span>
                  </b-col>
                  <b-col cols="7" xl="9">
                    <span class="item_value">{{
                      order.paymentData.amount
                    }}</span>
                  </b-col>
                </b-row>
                <hr />
              </b-col>
              <b-col cols="12" md="6">
                <b-row>
                  <b-col cols="5" xl="3">
                    <span class="item_title"> Paid Time</span>
                  </b-col>
                  <b-col cols="7" xl="9">
                    <span class="item_value">{{
                      formatDate(order.paymentData.created_at)
                    }}</span>
                  </b-col>
                </b-row>
                <hr />
              </b-col>
              <b-col cols="12" md="6">
                <b-row>
                  <b-col cols="5" xl="3">
                    <span class="item_title"> Payment Status</span>
                  </b-col>
                  <b-col cols="7" xl="9">
                    <span class="item_value" v-if="order.paymentData.paid"
                      >Paid</span
                    >
                    <span class="item_value" v-else>Not Paid</span>
                  </b-col>
                </b-row>
                <hr />
              </b-col>
              <b-col cols="12" md="6">
                <b-row>
                  <b-col cols="5" xl="3">
                    <span class="item_title"> Payment Id</span>
                  </b-col>
                  <b-col cols="7" xl="9">
                    <span class="item_value">{{
                      order.paymentData.paymentid
                    }}</span>
                  </b-col>
                </b-row>
                <hr />
              </b-col>
              <b-col cols="12" md="6">
                <b-row>
                  <b-col cols="5" xl="3">
                    <span class="item_title"> Razorpay Id</span>
                  </b-col>
                  <b-col cols="7" xl="9">
                    <span class="item_value">{{
                      order.paymentData.rzporderid
                    }}</span>
                  </b-col>
                </b-row>
                <hr />
              </b-col>
              <b-col cols="12" md="6">
                <b-row>
                  <b-col cols="5" xl="3">
                    <span class="item_title"> Refund Status</span>
                  </b-col>
                  <b-col cols="7" xl="9">
                    <span class="item_value">
                      {{ refundStatus }}
                    </span>
                  </b-col>
                </b-row>
                <hr />
              </b-col>
            </b-row>
            <b-row v-if="order.payment == 3">
              <b-col cols="12" md="6">
                <b-row>
                  <b-col cols="6" xl="4">
                    <span class="item_title"> Payment Method</span>
                  </b-col>
                  <b-col cols="6" xl="8">
                    <span class="item_value"> Self Pickup </span>
                  </b-col>
                </b-row>
                <hr />
              </b-col>
            </b-row>

            <template slot="footer">
              <b-button @click="$router.go(-1)" size="sm">Back</b-button>
            </template>
          </b-card>
        </transition>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      orderStatuses: [
        { name: "Payment Not Confirmed", value: 1, disabled: true },
        { name: "Placed", value: 2, disabled: true },
        { name: "Cancelled", value: 3, disabled: true },
        { name: "Rejected", value: 4, disabled: false },
        { name: "Confirmed", value: 5, disabled: false },
        { name: "Delivery En Route", value: 6, disabled: false },
        { name: "Deliver Complete", value: 7, disabled: false },
      ],
      orderStatus: null,
      orderStatusBtn: false,
      order: {
        customer: {},
        delivery_address: {},
        order_items: [],
        paymentData: {},
      },
      refundStatus: null,
      fields: [
        { key: "item_name", label: "Name", sortable: false },
        { key: "price", label: "Price", sortable: false },
        { key: "quantity", label: "Quantity", sortable: false },
        { key: "order_item", label: "Action", sortable: false },
      ],
      totalData: 0,
      currentPage: 1,
      perPage: 200,
      totalRows: 0,
      appLoading: false,
      ServerError: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    nextPage(ev) {
      this.currentPage = ev;
      this.getCategory();
    },

    getData() {
      this.appLoading = true;
      axios({
        url: "/order/" + this.$route.params.id,
        method: "GET",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.data) {
            this.order = response.data.data[0];
            if (this.order.status == 3) {
              this.orderStatusBtn = true;
            }
            if (this.order.payment == 2) {
              this.order.paymentData = response.data.data[0].paymentData[0];
              if (this.order.paymentData.refund) {
                this.refundMoney();
              }
            }
          }
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    confirmUpdateStatus() {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to update Order Status.", {
          title: "Please Confirm",
          size: "md",
          buttonSize: "sm",
          okVariant: "danger",
          cancelVariant: "primary",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            if (this.order.status == 4) {
              this.rejectOrder();
            } else {
              this.updateStatus();
            }
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    updateStatus() {
      this.appLoading = true;
      axios({
        method: "PUT",
        url: "/order/mark/status",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        data: {
          OrderID: this.order._id,
          Status: String(this.order.status),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.$notify({
              group: "appNotification",
              title: response.data.msg,
              text: "",
              type: "success",
            });
          } else {
            this.$notify({
              group: "appNotification",
              title: response.data.msg,
              text: "",
              type: "error",
            });
          }
        })
        .catch((e) => {
          console.log(e);
          this.ServerError = true;
        });
    },
    rejectOrder() {
      this.appLoading = true;
      axios({
        method: "PUT",
        url: "/order/reject",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        data: {
          orderid: this.order._id,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.$notify({
              group: "appNotification",
              title: response.data.msg,
              text: "",
              type: "success",
            });
          } else {
            this.$notify({
              group: "appNotification",
              title: response.data.msg,
              text: "",
              type: "error",
            });
          }
        })
        .catch((e) => {
          console.log(e);
          this.ServerError = true;
        });
    },
    refundMoney() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/refund/" + this.order.paymentData.refund_id,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.refundStatus = response.data.result.status;
          }
        })
        .catch((e) => {
          console.log(e);
          this.ServerError = true;
        });
    },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
    rowClicked(item) {
      this.$router.push("/Inventory/" + item.item_name + "/" + item.order_item);
    },
  },
};
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>
